/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]{margin-bottom:2px}.divider[_ngcontent-%COMP%]{margin-bottom:0}.desativado[_ngcontent-%COMP%]{background-color:#dd4b39;color:#fff;text-align:center;padding:5px;width:100%;margin:0 15px 7px}.funcionalidadeInativa[_ngcontent-%COMP%]{color:#a94442;font-weight:500}"];
export { styles as styles };
